module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('small', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _vm._l((_vm.stats.header), function(h) {
    return _c('th', {
      key: h
    }, [_vm._v(_vm._s(h))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.stats.coins), function(g, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(g.coin))]), _vm._v(" "), _vm._l((g.values), function(v, idxx) {
      return _c('td', {
        key: idx + '_' + idxx
      }, [_vm._v(_vm._s(_vm.stats.f(g.coin, v)))])
    })], 2)
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41207bd3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/stat-table.vue
// module id = 537
// module chunks = 1